import { IAdjunto } from '../interface/IAdjunto';

export class Adjunto implements IAdjunto {

  id: number;
  imagen: string;
  nuevaImagen?: any;
  activo: string;
  tipo: string;
  modificado?: boolean;
  esNuevo?: boolean;

  constructor(popup: IAdjunto) {
    this.id = popup.id;
    this.imagen = popup.imagen;
    this.nuevaImagen = popup.nuevaImagen;
    this.activo = popup.activo;
    this.tipo = popup.tipo;
    this.modificado = popup.modificado;
    this.esNuevo = popup.esNuevo;
  }

  getFormData(): FormData {
    const formData = new FormData();
    formData.append('activo', this.activo.toString());
    if (this.tipo) {
      formData.append('tipo', this.tipo.toString());
    }
    if (typeof this.nuevaImagen !== 'undefined') {
      formData.append('file_upload', this.nuevaImagen, this.nuevaImagen.name);
    }

    return formData;
  }

}



// WEBPACK FOOTER //
// /app/src/model/class/Adjunto.ts